const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

const INVENTORY_API_BASE_URL = (
  configuredBaseUrl || "https://nodei.ssccglpinnacle.com"
).replace(/\/+$/, "");

export default INVENTORY_API_BASE_URL;
